import script from "./ViewDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ViewDetails.vue?vue&type=style&index=0&id=2e3f63cc&scoped=true&lang=less"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3f63cc"]])

export default __exports__